export const connectData = [
  {
    id: 1,
    img: require("../../assets/connectCity/helsinki.png"),
  },
];
